window.s1.wpDataStack = window.s1.wpDataStack || {};

// Function to get all URL parameters and return them as a string
const getUrlParameters = () => {
  const params = new URLSearchParams(window.location.search);
  return params.toString();
};

// Function to append URL parameters to all links with .cta-btn class
const appendParamsToLinks = () => {
  const micrositeName = window.s1?.wpDataStack?.microsite_name ?? '';
  if (micrositeName !== 'tips-howstuffworks') {
    return false;
  }

  const urlParams = getUrlParameters();

  if (urlParams) {
    const ctaButtons = document.querySelectorAll('.cta-btn');
    ctaButtons.forEach((button) => {
      const currentUrl = button.href;
      const separator = currentUrl.includes('?') ? '&' : '?';
      /* eslint no-param-reassign:
      ["error", { "props": true, "ignorePropertyModificationsFor": ["button"] }]
      */
      if (currentUrl !== window.location.href) {
        button.href = `${currentUrl}${separator}${urlParams}`;
      }
    });
  }
  return true;
};

const appendQueryStringParams = () => {
  appendParamsToLinks();
};

export default appendQueryStringParams;
